import { cmsApi } from '../constants/constants';
import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var SentemailService = /** @class */ (function () {
    function SentemailService(http) {
        this.http = http;
    }
    SentemailService.prototype.setEmail = function (subject, name, Tel, Email, Detail) {
        var _getNewsPeriodUrl = cmsApi + '/sentmail/';
        var _getNewsPeriodBody = {
            subject: subject,
            name: name,
            Tel: Tel,
            Email: Email,
            Detail: Detail
        };
        return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody);
    };
    SentemailService.ngInjectableDef = i0.defineInjectable({ factory: function SentemailService_Factory() { return new SentemailService(i0.inject(i1.HttpClient)); }, token: SentemailService, providedIn: "root" });
    return SentemailService;
}());
export { SentemailService };
